<span class="names">
    <ng-container *ngIf="names$ | async as names; else login">
        {{ names.first_name }} {{ names.last_name }}
    </ng-container>
</span>

<ng-template #login> {{ (texts$ | async)?.my_account }} </ng-template>
